export const removeQueryParamsFromUrl = (): void => {
    window.history.replaceState({}, '', window.location.href.split('?')[0])
}
